import type { CoverSheetConfigCard } from '../../../types';

export const rentCard = {
  id: 'propertyInfo.rent',
  innerTitle: 'Rent',
  legend: '',
  layout: [
    [
      {
        name: 'monthlyRent',
        size: 50,
      },
      {
        name: 'totalRentAmount',
        size: 50,
      },
    ],
  ],
  fields: {
    monthlyRent: {
      name: 'monthlyRent',
      entity: 'interaction',
      type: 'money',
      label: 'Monthly Rent Amount',
      placeholderText: '',
    },
    totalRentAmount: {
      name: 'totalRentAmount',
      entity: 'interaction',
      type: 'money',
      label: 'Total Rent Amount',
      placeholderText: '',
    },
  },
} satisfies CoverSheetConfigCard;
